// extracted by mini-css-extract-plugin
module.exports = {"box":"box--uLMxA","newsTab":"newsTab--594kh","active":"active--J8H3d"};